<template>
	<appBaseModal v-if="shouldShowModal">	
		<div slot="content">
			
			<div class="modal__head">
				<div class="modal__head__title">Presentation Options</div>
				<div class="modal__head__subtitle">All options use a comprehensive BIM compliant layering system.</div>
				<div class="modal__pres__controls">

					<div class="col md-4 modal__pres__control">
						<button @click="updatePresImg('pres-op--low-colour.png'), activeBtn = 'btn1'" :class="{active: activeBtn === 'btn1' }" class="outline">Low Colour</button>
					</div>

					<div class="col md-4 modal__pres__control">
						<button @click="updatePresImg('pres-op--std.png'), activeBtn = 'btn2'" :class="{active: activeBtn === 'btn2' }" class="outline">Standard</button>
					</div>

					<div class="col md-4 modal__pres__control">
						<button @click="updatePresImg('pres-op--high-colour.png'), activeBtn = 'btn3'" :class="{active: activeBtn === 'btn3' }" class="outline">High Colour</button>
					</div>

					<div class="clearfix"></div>

				</div>
				<div class="clearfix"></div>
			</div>
			<div class="modal__content modal__content--pres">
				<div class="col md-12">
					<img :src="require('@/assets/images/' + modalPresImg)" alt="">
				</div>
				<div class="clearfix"></div>
				<button class="primary pres-close" @click="closeModaler">Close</button>
			</div>

		</div>
	</appBaseModal>
</template>

<script>
    import BaseModal from './BaseModal';
	export default {
		components : {
			appBaseModal : BaseModal
		},
		data(){
			return {
				compName : 'PresentationOptionsModal',
				modalPresImg: 'pres-op--std.png',
				activeBtn:'btn2'
			}
		},
		computed : {
			shouldShowModal(){
				return this.$store.getters.getModalActive.modalName === this.compName
			}
		},
		methods: {
			updatePresImg: function (message) {
				// Vue.set(this.modalPresImg, 'test')
				// alert(this.modalPresImg)
				this.modalPresImg = message
			},
			closeModaler(){
				return this.$store.commit('closeModal', '');
			}		
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/Modals/PresentationOptionsModal.vue